export default "__VITE_ASSET__c34e0e88__"